import "antd/dist/antd.css";
import { Form, Input, Button, Switch, Spin } from "antd";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import StandardFormLayout from "../../layouts/StandardFormLayout/StandardFormLayout";
import { useState, useEffect } from "react";
import {
  CREATING_EMPLOYMENT_TYPE,
  FETCH_DETAIL_EMPLOYMENT_TYPE_IN_ORGANISATION,
  NEW_EMPLOYMENT_TYPE,
  setDetailEmploymentType,
  UPDATING_EMPLOYMENT_TYPE,
} from "../../store/team-member-store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
const EditEmploymentTypes = () => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { idType } = useParams();
  const { pathname } = useLocation();
  const { detailEmploymentType } = useSelector(({ team }) => team.teamReducer);
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const onFinish = async (values) => {
    setLoading(true);
    values.organisationId = organisationId;
    values._id = detailEmploymentType._id;
    if (idType === "new") {
      CREATING_EMPLOYMENT_TYPE(values).then((data) => {
        setLoading(false);
        navigate("/employment/types");
      });
    } else {
      UPDATING_EMPLOYMENT_TYPE(values).then((data) => {
        setLoading(false);
        navigate("/employment/types");
      });
    }
  };

  useEffect(() => {
    const updateState = () => {
      if (idType === "new") {
        dispatch(NEW_EMPLOYMENT_TYPE());
        setInitialLoading(false);
      } else {
        FETCH_DETAIL_EMPLOYMENT_TYPE_IN_ORGANISATION(idType).then((data) => {
          dispatch(setDetailEmploymentType(data));
          setInitialLoading(false);
        });
      }
    };
    updateState();
  }, [dispatch, idType]);

  useEffect(() => {
    if (detailEmploymentType) {
      form.setFields([
        {
          name: "description",
          value: detailEmploymentType.description,
        },
        {
          name: "status",
          value: detailEmploymentType.status,
        },
      ]);
    }
  }, [detailEmploymentType]);

  return (
    <StandardFormLayout
      hierachy={[
        { key: 1, label: "Employment Types", path: "/employment/types" },
        { key: 2, label: pathname.indexOf("new") === -1 ? "Edit" : "New" },
      ]}
      editPath="/employment/types/new"
      form={
        initialLoading ? (
          <Spin spinning={initialLoading} indicator={antIcon}></Spin>
        ) : (
          <Form
            labelAlign="left"
            form={form}
            requiredMark={false}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 8 }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Status" name="status" valuePropName="checked">
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        )
      }
    />
  );
};

export default EditEmploymentTypes;
